var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-form",
        { ref: "unitary_form" },
        [
          _c(
            "v-container",
            { staticClass: "pa-0", attrs: { "grid-list-xs": "", fluid: "" } },
            [
              _vm.form.parameters.hasOwnProperty(_vm.parameters_names.job_title)
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "mb-1 background--text text--lighten-5 subheading"
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm._f("maestroParamLabel")(
                                  _vm.parameters[_vm.parameters_names.job_title]
                                )
                              ) +
                              "\n\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-text-field", {
                        staticClass: "grv-input",
                        attrs: {
                          solo: "",
                          name: _vm.parameters_names.job_title,
                          rules: _vm.getValidationRules(
                            _vm.parameters_names.job_title
                          )
                        },
                        model: {
                          value:
                            _vm.form.parameters[_vm.parameters_names.job_title],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form.parameters,
                              _vm.parameters_names.job_title,
                              $$v
                            )
                          },
                          expression:
                            "form.parameters[parameters_names.job_title]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.parameters.hasOwnProperty(
                _vm.parameters_names.output_folder
              )
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "mb-1 background--text text--lighten-5 subheading"
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm._f("maestroParamLabel")(
                                  _vm.parameters[
                                    _vm.parameters_names.output_folder
                                  ]
                                )
                              ) +
                              "\n\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-text-field", {
                        ref: _vm.parameters_names.output_folder,
                        staticClass: "file-input grv-input",
                        attrs: {
                          solo: "",
                          name: _vm.parameters_names.output_folder,
                          rules: _vm.getValidationRules(
                            _vm.parameters_names.output_folder
                          ),
                          prefix: _vm.getFileBasename(
                            _vm.form.parameters[
                              _vm.parameters_names.output_folder
                            ]
                          ),
                          "append-icon": "folder_open"
                        },
                        on: {
                          change: function($event) {
                            return _vm.outputFolderPathCleaner(
                              _vm.parameters_names.output_folder
                            )
                          },
                          "click:append": function($event) {
                            return _vm.showFileExplorer(
                              _vm.parameters[
                                _vm.parameters_names.output_folder
                              ],
                              null
                            )
                          }
                        },
                        model: {
                          value:
                            _vm.form.parameters[
                              _vm.parameters_names.output_folder
                            ],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form.parameters,
                              _vm.parameters_names.output_folder,
                              $$v
                            )
                          },
                          expression:
                            "form.parameters[parameters_names.output_folder]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", "align-start": "" } },
                [
                  _vm.form.parameters.hasOwnProperty(
                    _vm.parameters_names.audio_config
                  )
                    ? _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mb-1 background--text text--lighten-5 subheading"
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("maestroParamLabel")(
                                      _vm.parameters[
                                        _vm.parameters_names.audio_config
                                      ]
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            staticClass: "grv-input pr-2",
                            attrs: {
                              solo: "",
                              dense: "",
                              name: _vm.parameters_names.audio_config,
                              "menu-props": { contentClass: "grv-menu" },
                              rules: _vm.getValidationRules(
                                _vm.parameters_names.audio_config
                              ),
                              items:
                                _vm.parameters[
                                  _vm.parameters_names.audio_config
                                ].choices
                            },
                            on: {
                              change: function($event) {
                                return _vm.onAudioConfChange($event)
                              }
                            },
                            model: {
                              value:
                                _vm.form.parameters[
                                  _vm.parameters_names.audio_config
                                ],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.parameters,
                                  _vm.parameters_names.audio_config,
                                  $$v
                                )
                              },
                              expression:
                                "form.parameters[parameters_names.audio_config]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.parameters.hasOwnProperty(
                    _vm.parameters_names.measurement_algorithm
                  )
                    ? _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mb-1 background--text text--lighten-5 subheading"
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("maestroParamLabel")(
                                      _vm.parameters[
                                        _vm.parameters_names
                                          .measurement_algorithm
                                      ]
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            staticClass: "grv-input pr-2",
                            attrs: {
                              solo: "",
                              dense: "",
                              name: _vm.parameters_names.measurement_algorithm,
                              "menu-props": { contentClass: "grv-menu" },
                              rules: _vm.getValidationRules(
                                _vm.parameters_names.measurement_algorithm
                              ),
                              items:
                                _vm.parameters[
                                  _vm.parameters_names.measurement_algorithm
                                ].choices
                            },
                            model: {
                              value:
                                _vm.form.parameters[
                                  _vm.parameters_names.measurement_algorithm
                                ],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.parameters,
                                  _vm.parameters_names.measurement_algorithm,
                                  $$v
                                )
                              },
                              expression:
                                "form.parameters[parameters_names.measurement_algorithm]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.parameters.hasOwnProperty(
                    _vm.parameters_names.downmix_output_config
                  )
                    ? _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mb-1 background--text text--lighten-5 subheading"
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("maestroParamLabel")(
                                      _vm.parameters[
                                        _vm.parameters_names
                                          .downmix_output_config
                                      ]
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            staticClass: "grv-input pr-2",
                            attrs: {
                              solo: "",
                              dense: "",
                              name: _vm.parameters_names.downmix_output_config,
                              "menu-props": { contentClass: "grv-menu" },
                              rules: _vm.getValidationRules(
                                _vm.parameters_names.downmix_output_config
                              ),
                              items:
                                _vm.parameters[
                                  _vm.parameters_names.downmix_output_config
                                ].choices
                            },
                            model: {
                              value:
                                _vm.form.parameters[
                                  _vm.parameters_names.downmix_output_config
                                ],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.parameters,
                                  _vm.parameters_names.downmix_output_config,
                                  $$v
                                )
                              },
                              expression:
                                "form.parameters[parameters_names.downmix_output_config]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.parameters.hasOwnProperty(
                    _vm.parameters_names.upmix_output_config
                  )
                    ? _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mb-1 background--text text--lighten-5 subheading"
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("maestroParamLabel")(
                                      _vm.parameters[
                                        _vm.parameters_names.upmix_output_config
                                      ]
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            staticClass: "grv-input pr-2",
                            attrs: {
                              solo: "",
                              dense: "",
                              name: _vm.parameters_names.upmix_output_config,
                              "menu-props": { contentClass: "grv-menu" },
                              rules: _vm.getValidationRules(
                                _vm.parameters_names.upmix_output_config
                              ),
                              items:
                                _vm.parameters[
                                  _vm.parameters_names.upmix_output_config
                                ].choices
                            },
                            model: {
                              value:
                                _vm.form.parameters[
                                  _vm.parameters_names.upmix_output_config
                                ],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.parameters,
                                  _vm.parameters_names.upmix_output_config,
                                  $$v
                                )
                              },
                              expression:
                                "form.parameters[parameters_names.upmix_output_config]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.parameters.hasOwnProperty(
                    _vm.parameters_names.varispeed_config
                  )
                    ? _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mb-1 background--text text--lighten-5 subheading"
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("maestroParamLabel")(
                                      _vm.parameters[
                                        _vm.parameters_names.varispeed_config
                                      ]
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            staticClass: "grv-input pr-2",
                            attrs: {
                              solo: "",
                              dense: "",
                              name: _vm.parameters_names.varispeed_config,
                              "menu-props": { contentClass: "grv-menu" },
                              rules: _vm.getValidationRules(
                                _vm.parameters_names.varispeed_config
                              ),
                              items:
                                _vm.parameters[
                                  _vm.parameters_names.varispeed_config
                                ].choices
                            },
                            model: {
                              value:
                                _vm.form.parameters[
                                  _vm.parameters_names.varispeed_config
                                ],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.parameters,
                                  _vm.parameters_names.varispeed_config,
                                  $$v
                                )
                              },
                              expression:
                                "form.parameters[parameters_names.varispeed_config]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.parameters.hasOwnProperty(
                    _vm.parameters_names.qt_profile
                  )
                    ? _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mb-1 background--text text--lighten-5 subheading"
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("maestroParamLabel")(
                                      _vm.parameters[
                                        _vm.parameters_names.qt_profile
                                      ]
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            staticClass: "grv-input pr-2",
                            attrs: {
                              solo: "",
                              dense: "",
                              name: _vm.parameters_names.qt_profile,
                              "menu-props": { contentClass: "grv-menu" },
                              rules: _vm.getValidationRules(
                                _vm.parameters_names.qt_profile
                              ),
                              items:
                                _vm.parameters[_vm.parameters_names.qt_profile]
                                  .choices
                            },
                            model: {
                              value:
                                _vm.form.parameters[
                                  _vm.parameters_names.qt_profile
                                ],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.parameters,
                                  _vm.parameters_names.qt_profile,
                                  $$v
                                )
                              },
                              expression:
                                "form.parameters[parameters_names.qt_profile]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.parameters.hasOwnProperty(_vm.parameters_names.fps)
                    ? _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mb-1 background--text text--lighten-5 subheading"
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("maestroParamLabel")(
                                      _vm.parameters[_vm.parameters_names.fps]
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            staticClass: "grv-input pr-2",
                            attrs: {
                              solo: "",
                              dense: "",
                              name: _vm.parameters_names.fps,
                              "menu-props": { contentClass: "grv-menu" },
                              rules: _vm.getValidationRules(
                                _vm.parameters_names.fps
                              ),
                              items:
                                _vm.parameters[_vm.parameters_names.fps].choices
                            },
                            model: {
                              value:
                                _vm.form.parameters[_vm.parameters_names.fps],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.parameters,
                                  _vm.parameters_names.fps,
                                  $$v
                                )
                              },
                              expression:
                                "form.parameters[parameters_names.fps]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.parameters.hasOwnProperty(
                    _vm.parameters_names.measurement_only
                  )
                    ? _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c("v-checkbox", {
                            staticClass: "mb-0 pr-2 grv-input",
                            staticStyle: { "padding-top": "32px !important" },
                            attrs: {
                              "hide-details": "",
                              name: _vm.parameters_names.measurement_only,
                              label: _vm._f("maestroParamLabel")(
                                _vm.parameters[
                                  _vm.parameters_names.measurement_only
                                ]
                              ),
                              color: "primary"
                            },
                            model: {
                              value:
                                _vm.form.parameters[
                                  _vm.parameters_names.measurement_only
                                ],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.parameters,
                                  _vm.parameters_names.measurement_only,
                                  $$v
                                )
                              },
                              expression:
                                "form.parameters[parameters_names.measurement_only]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.parameters.hasOwnProperty(
                    _vm.parameters_names.harmonize
                  )
                    ? _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c("v-checkbox", {
                            staticClass: "mb-0 pr-2 grv-input",
                            staticStyle: { "padding-top": "32px !important" },
                            attrs: {
                              "hide-details": "",
                              name: _vm.parameters_names.harmonize,
                              label: _vm._f("maestroParamLabel")(
                                _vm.parameters[_vm.parameters_names.harmonize]
                              ),
                              color: "primary"
                            },
                            model: {
                              value:
                                _vm.form.parameters[
                                  _vm.parameters_names.harmonize
                                ],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.parameters,
                                  _vm.parameters_names.harmonize,
                                  $$v
                                )
                              },
                              expression:
                                "form.parameters[parameters_names.harmonize]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.parameters.hasOwnProperty(
                    _vm.parameters_names.do_r128
                  )
                    ? _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c("v-checkbox", {
                            staticClass: "mb-0 pr-2 grv-input",
                            staticStyle: { "padding-top": "32px !important" },
                            attrs: {
                              "hide-details": "",
                              name: _vm.parameters_names.do_r128,
                              label: _vm._f("maestroParamLabel")(
                                _vm.parameters[_vm.parameters_names.do_r128]
                              ),
                              color: "primary"
                            },
                            model: {
                              value:
                                _vm.form.parameters[
                                  _vm.parameters_names.do_r128
                                ],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.parameters,
                                  _vm.parameters_names.do_r128,
                                  $$v
                                )
                              },
                              expression:
                                "form.parameters[parameters_names.do_r128]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.parameters.hasOwnProperty(
                    _vm.parameters_names.dialogue_measurement
                  )
                    ? _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c("v-checkbox", {
                            staticClass: "mb-0 pr-2 grv-input",
                            staticStyle: { "padding-top": "32px !important" },
                            attrs: {
                              "hide-details": "",
                              name: _vm.parameters_names.dialogue_measurement,
                              label: _vm._f("maestroParamLabel")(
                                _vm.parameters[
                                  _vm.parameters_names.dialogue_measurement
                                ]
                              ),
                              color: "primary"
                            },
                            model: {
                              value:
                                _vm.form.parameters[
                                  _vm.parameters_names.dialogue_measurement
                                ],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.parameters,
                                  _vm.parameters_names.dialogue_measurement,
                                  $$v
                                )
                              },
                              expression:
                                "form.parameters[parameters_names.dialogue_measurement]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.parameters.hasOwnProperty(
                    _vm.parameters_names.r128_measurement
                  )
                    ? _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c("v-checkbox", {
                            staticClass: "mb-0 pr-2 grv-input",
                            staticStyle: { "padding-top": "32px !important" },
                            attrs: {
                              "hide-details": "",
                              name: _vm.parameters_names.r128_measurement,
                              label: _vm._f("maestroParamLabel")(
                                _vm.parameters[
                                  _vm.parameters_names.r128_measurement
                                ]
                              ),
                              color: "primary"
                            },
                            model: {
                              value:
                                _vm.form.parameters[
                                  _vm.parameters_names.r128_measurement
                                ],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.parameters,
                                  _vm.parameters_names.r128_measurement,
                                  $$v
                                )
                              },
                              expression:
                                "form.parameters[parameters_names.r128_measurement]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.parameters.hasOwnProperty(
                _vm.parameters_names.audio_tracks
              )
                ? _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                    _vm.audio_tracks.length
                      ? _c("table", { attrs: { id: "audio-table" } }, [
                          _c("colgroup", [
                            _c("col", { staticStyle: { width: "40px" } }),
                            _vm._v(" "),
                            _c("col"),
                            _vm._v(" "),
                            _c("col", { staticStyle: { width: "200px" } })
                          ]),
                          _vm._v(" "),
                          _c("thead", [
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-0",
                                      attrs: {
                                        flat: "",
                                        icon: "",
                                        color: "warning",
                                        disabled: _vm.hasNoAudioSelected()
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.emptyTracks("all")
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("close")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _c("span", { staticClass: "subheading" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm._f("maestroParamLabel")(
                                          _vm.parameters[
                                            _vm.parameters_names.audio_tracks
                                          ]
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "px-2" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        block: "",
                                        color: "green accent-3 color--text",
                                        disabled: !_vm.audio_tracks[0].path,
                                        loading: _vm.probing
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.validateTracks()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\tValidation\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(_vm.audio_tracks, function(track, i) {
                                return [
                                  _vm.current_segments.length > 1 &&
                                  _vm.segmentStartLabel(i)
                                    ? _c(
                                        "tr",
                                        {
                                          key: "segment_" + i,
                                          staticClass: "mix-separator"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "ma-0",
                                                  attrs: {
                                                    flat: "",
                                                    icon: "",
                                                    color: "warning",
                                                    disabled: _vm.hasMixNoAudioSelected(
                                                      i
                                                    )
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.emptyMixTracks(
                                                        i
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("close")
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { attrs: { colspan: "2" } },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\tMix " +
                                                  _vm._s(
                                                    _vm.segmentStartLabel(i)
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("tr", { key: "track_" + i }, [
                                    _c(
                                      "td",
                                      { staticClass: "text-center" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "ma-0",
                                            attrs: {
                                              flat: "",
                                              icon: "",
                                              color: "warning",
                                              disabled: !track.path
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.emptyTracks(i)
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("close")])],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "v-input",
                                          {
                                            ref:
                                              _vm.parameters_names.audio_tracks,
                                            refInFor: true,
                                            staticClass:
                                              "file-input grv-input grv-input-dense",
                                            attrs: {
                                              readonly: "",
                                              solo: "",
                                              "hide-details": "",
                                              loading:
                                                track.probe ===
                                                "__in_progress__",
                                              name:
                                                _vm.parameters_names
                                                  .audio_tracks,
                                              rules: _vm.getValidationRules(
                                                _vm.parameters_names
                                                  .audio_tracks,
                                                i
                                              )
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "prepend",
                                                  fn: function() {
                                                    return [
                                                      _vm.audioconfig_mapping.hasOwnProperty(
                                                        _vm.form.parameters[
                                                          _vm.parameters_names
                                                            .audio_config
                                                        ]
                                                      )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm
                                                                    .audioconfig_mapping[
                                                                    _vm.form
                                                                      .parameters[
                                                                      _vm
                                                                        .parameters_names
                                                                        .audio_config
                                                                    ]
                                                                  ][i]
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  },
                                                  proxy: true
                                                },
                                                {
                                                  key: "append",
                                                  fn: function() {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "ma-0 ml-1",
                                                          attrs: {
                                                            flat: "",
                                                            icon: "",
                                                            small: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.showFileExplorer(
                                                                _vm.parameters[
                                                                  _vm
                                                                    .parameters_names
                                                                    .audio_tracks
                                                                ],
                                                                i
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "folder_open"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: track.path,
                                              callback: function($$v) {
                                                _vm.$set(track, "path", $$v)
                                              },
                                              expression: "track.path"
                                            }
                                          },
                                          [
                                            _vm._v(" "),
                                            _vm._v(" "),
                                            _c("span"),
                                            _vm._v(" "),
                                            _c("v-hover", {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var hover = ref.hover
                                                      return _c("span", {}, [
                                                        hover
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "caption background--text text--lighten-5"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      track.path
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _c("span", [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "fileBasename"
                                                                    )(
                                                                      track.path
                                                                    )
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ])
                                                      ])
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "pa-1 text-center",
                                        staticStyle: { "line-height": "1.2" }
                                      },
                                      [
                                        _vm.getDuplicateIndexFor(i) !== -1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "error--text font-weight-bold"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\tDoublon avec piste " +
                                                    _vm._s(
                                                      _vm.getDuplicateIndexFor(
                                                        i
                                                      ) + 1
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          : track.probe === "__in_progress__"
                                          ? _c(
                                              "div",
                                              [
                                                _c("v-progress-circular", {
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "primary",
                                                    width: 2
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : track.valid === true
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "green--text text--accent-3"
                                              },
                                              [
                                                _c("span", {
                                                  directives: [
                                                    {
                                                      name: "safe-html",
                                                      rawName: "v-safe-html",
                                                      value: track.probe,
                                                      expression: "track.probe"
                                                    }
                                                  ]
                                                })
                                              ]
                                            )
                                          : track.valid === false
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "error--text font-weight-bold"
                                              },
                                              [
                                                _c("span", {
                                                  directives: [
                                                    {
                                                      name: "safe-html",
                                                      rawName: "v-safe-html",
                                                      value: track.probe,
                                                      expression: "track.probe"
                                                    }
                                                  ]
                                                })
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "warning--text subheading"
                                              },
                                              [_vm._v("- - -")]
                                            )
                                      ]
                                    )
                                  ])
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.explorer.show
        ? _c("Explorer", {
            attrs: {
              assetType: _vm.explorer.asset_type,
              multiselect: false,
              default_folder: _vm.explorer.default_value,
              return_dir_filelist: _vm.explorer.return_dir_filelist,
              toolbarTitle: "Selectionnez des assets présents sur le filesystem"
            },
            on: {
              close: function($event) {
                return _vm.onExplorerClose()
              },
              selectedAssets: function($event) {
                return _vm.onSelectedAssets($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "hide-overlay": "",
            persistent: "",
            "max-width": "fit-content"
          },
          model: {
            value: _vm.check_path_loader.active,
            callback: function($$v) {
              _vm.$set(_vm.check_path_loader, "active", $$v)
            },
            expression: "check_path_loader.active"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { color: "primary" } },
            [
              _c(
                "v-card-text",
                { staticClass: "text-center" },
                [
                  _c("span", { staticClass: "color--text headline" }, [
                    _vm._v("\n\t\t\t\t\tCheck Path\n\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "color--text subheading" }, [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.check_path_loader.path) +
                        "\n\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-progress-linear", {
                    staticClass: "mb-0",
                    attrs: { indeterminate: "", color: "color" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a883c698", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a883c698","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/launcher/forms/launcher_form_audiotools_audiofiles.vue
// module id = null
// module chunks = 